module.exports = __webpack_public_path__ + "img/kf.946e5c44.png";